import { getStore } from '../store/Store';

/**
 * Selector to determine if header load failed or not
 */
export const didReadingPaneHeaderLoadFail = () => !!getStore().ReadingPaneHeader.lazyLoadingFailed;
